import axios from 'axios';
import _ from 'lodash';
import dayjs from 'dayjs';
import qs from 'qs';
import { OrderStatuses, } from '@tradingblock/types';
import axiosRetry from 'axios-retry';
// export function toApiResponse<D>(resp: ApiResponse<D> | LegacyApiResponse<D>): ApiResponse<D> {
//   const payload: D = _.get(resp, 'Payload', undefined) || _.get(resp, 'payload', undefined);
//   const responseCode: ResponseCode = _.get(resp, 'ResponseCode', undefined) || _.get(resp, 'responseCode', undefined);
//   return {
//     payload,
//     responseCode,
//   };
// }
const clients = {};
export const createAxiosClient = (url, token) => {
    // Check if we already have a client instance for this url and token
    if (clients[`${url}-${token}`] !== undefined) {
        return clients[`${url}-${token}`];
    }
    const client = axios.create({
        baseURL: url,
        headers: { Authorization: token, Accept: 'application/json' },
    });
    axiosRetry(client, {
        retries: 3,
        retryCondition: e => {
            // Don't retry on 429 (rate limit) to prevent compounding the issue
            return axiosRetry.isNetworkOrIdempotentRequestError(e) && e.response && e.response.status !== 429;
        },
        shouldResetTimeout: true,
        retryDelay: (retryCount, error) => {
            if (error.response && error.response.headers !== undefined) {
                const retry_after = error.response.headers['retry-after'];
                console.log('Retrying after: ', retry_after);
                if (retry_after) {
                    return retry_after * 1000;
                }
            }
            // Exponential backoff with jitter to prevent thundering herd
            const baseDelay = Math.min(1000 * Math.pow(2, retryCount), 10000); // Cap at 10 seconds
            const jitter = Math.random() * 1000; // Add up to 1 second of jitter
            return baseDelay + jitter;
        },
        onRetry: (retryCount, error, requestConfig) => {
            console.log(`Retry attempt #${retryCount} for ${requestConfig.url}`);
            console.log(`Error `, error);
        },
    });
    //Create a cache version of clients to prevent multiple clients from being created
    clients[`${url}-${token}`] = client;
    return client;
};
export const formatUrl = (url, querystringParams) => {
    const delim = url.indexOf('?') > -1 ? '&' : '?';
    var params = querystringParams ? qs.stringify(querystringParams, { arrayFormat: 'comma' }) : null;
    return `${url}${params ? delim + params : ''}`;
};
export function isString(x) {
    return typeof x === 'string';
}
export function getIdNumber(id) {
    return _.toNumber(id);
}
export const DateFormats = {
    ApiFormat: 'MM-DD-YYYY',
    DateTimeApiFormat: 'YYYY-MM-DD hh:mm:ss',
};
export const dateStringOrUndefined = (dateOrString, format) => {
    //if (dateOrString === undefined || isString(dateOrString)) return dateOrString;
    const dateValue = dateOrString === undefined || isString(dateOrString) ? dayjs(dateOrString).toDate() : dateOrString;
    if (format === undefined) {
        return dayjs(dateValue)
            .toDate()
            .toISOString();
    }
    return dayjs(dateValue).format(format);
};
export function isInfinity(val) {
    return val === 'Infinity';
}
export function isHeartbeat(val) {
    return val.type === 'HeartBeat';
}
export function isExpiredToken(val) {
    return val.type === 'ExpiredToken';
}
export function isOrderUpdate(val) {
    return val.type === 'OrderUpdate';
}
export function isQuote(val) {
    return val.type === 'Quote';
}
export function isSpread(val) {
    return val.type === 'Spread';
}
export function isSettlement(val) {
    return val.type === 'Settlement';
}
export function getOrderStatus(val) {
    const match = _.map(OrderStatuses, (s, k) => ({ status: k, value: s })).find(v => v.value === val);
    return match;
}
export function isCashieringUpdate(val) {
    return val.type === 'CashieringUpdate';
}
export function isAccountApplicationUpdate(val) {
    return val.type === 'AccountApplicationUpdate';
}
export function isOpenPriceUpdate(val) {
    return val.type === 'OpenPriceUpdate';
}
//# sourceMappingURL=utilities.js.map